import { API_BASE_URL, AI_BASE_URL, SOCKETURL, EXTERNAL_URL } from "./site_urls";

export const APPLICATION_NAME = "Dr. Jobs";
export const STORAGE = "DR-JOBS-APP";
export const REFRESH_STORAGE = "DR-JOBS-REFRESH-TOKEN";
export const SELECTED_EVENT_STORAGE = `${APPLICATION_NAME}-Event`;
export const SELECTED_PWA_STORAGE = `${APPLICATION_NAME}-PWA`;
export const APPLICATION_GLOBAL_SLUG = "drjobs";
export const PAGE_TITLE = `${APPLICATION_NAME} - `;
export const FILE_BASE_PATH = "";
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_STAGE = process.env.REACT_APP_STAGE;
export const CRYPTO_SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || "";
export const SOCKET_URL = SOCKETURL;
export const PER_PAGE = 8;
export const REFRESH_INTERVAL = 86400; // 24 hours in seconds
export const DATE_FORMAT = "MM/dd/yyyy";

// Agora Configuration
export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID || "";
export const AGORA_APP_CERTIFICATE = process.env.REACT_APP_AGORA_APP_CERTIFICATE || "";

export const DATE_ALL_FORMAT = {
  DATE_PICKER_FORMAT: "MM/dd/yyyy",
  MOMENT_FORMAT: "MM/DD/yyyy",
};

export const CHAT_DATE_TIME_FORMAT = {
  DISPLAY_DATE_WITH_TIME: "Do MMMM, YYYY hh:mm a",
  DISPLAY_DAY_TIME: "dddd hh:mm a",
};
export const TIME_CONFIG = {
  TIME_FORMAT: "hh:mm a",
  TIME_INTERVALS: 5,
};
export const DEFAULT_LATITUDE = "31.9686";
export const DEFAULT_LONGITUDE = "-99.9018";

export const URLS = {
  AUTH: {
    LOGIN: "/",
    REGISTRATION: "/registration",
    COMPLETE_PROFILE: "/complete-profile",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    VERIFY_EMAIL: "/verify-email",
    MY_PROFILE: "/my-profile",
    VIEW_PROFILE: "/view-profile",
    EDIT_PROFILE: "/edit-profile",
    AUTO_LOGIN: (email: string) => (email ? `/autologin/${email}` : "/autologin/:email"),
    AUTO_LOGIN_TOKEN: "/autologin",
  },

  CMS: {
    CMS: "/cms/:slug",
  },

  DASHBOARD: {
    MAIN: "/dashboard",
  },
  JOB_POSTING: {
    NEW: "/job-create",
    EDIT: (jobId: string) => (jobId ? `/job-edit/${jobId}` : "/job-edit/:jobId"),
    AI_DESCRIPTION: "/job-create-step2",
    THANK_YOU: (jobType: string, jobId?: string) =>
      jobType && jobId ? `/job-posted-successfully/${jobType}/${jobId}` : "/job-posted-successfully/:jobType/:jobId?",
    MY_JOBS: "/my-jobs",
    JOB_LISTINGS: "/job-listings",
    AI_CANDIDATE_SEARCH: "/ai-candidate-search",
    AI_CANDIDATE_SEARCH_EDIT: (jobId: string) =>
      jobId ? `/ai-candidate-search-edit/${jobId}` : "/ai-candidate-search-edit/:jobId",
    JOB_DETAILS: "/job-details/:jobId",
    //TALENT_SCOUTING: "/talent-scouting/:jobId",
    OFFER_RESPONSE: "/offer-response/:offerType/:screeningId/:userId",
    INTERVIEW_RESPONSE: "/interview-response/:responseType/:screeningId/:userId?",
  },
  INTERVIEW: {
    AVALIBILITY: "/interview-schedule",
    VIDEO_CALL: (interviewId: string) => (interviewId ? `/interview/${interviewId}` : "/interview/:interviewId"),
  },
  INSTANT_MEET: {
    VIDEO_CALL: (meetingId: string) => (meetingId ? `/instant-call/${meetingId}` : "/instant-call/:meetingId"),
  },

  MEMBERS: {
    LIST: "/members",
    ADD: "/members/add",
    EDIT: (memberId: string) => (memberId ? `/members/edit/${memberId}` : "/members/edit/:memberId"),
    PERMISSIONS: "/members/permissions",
  },
  SETTINGS: {
    SECURITY: "/settings/security",
    SUBSCRIPTIONS: "/settings/subscriptions",
    BILLING: "/settings/billing",
    HISTORY: "/settings/history",
    PAYMENT_SUCCESS: "/subscription-plans/payment/success",
    PAYMENT_CANCEL: "/subscription-plans/payment/cancel",
  },
  REPORTS: {
    MAIN: "/reports",
  },
  VIDEO_CV: {
    MAIN: "/video-cv",
  },
  CANDIDATES: {
    MAIN: "/candidates",
  },
  CANDIDATE_ADVANCED_SEARCH: {
    MAIN: "/candidate-advanced-search",
  },
  NOTIFICATIONS: {
    MAIN: "/notifications",
  },
  SUPPORT: {
    CONTACT_US: "/contact-us",
  },
};

export const API_URL = {
  // API URL
  USER: {
    LOGIN: `${API_BASE_URL}login`,
    LOGOUT: `${API_BASE_URL}auth/logout`,
    REFRESH: `${API_BASE_URL}auth/refresh`,
    DETAILS: `${API_BASE_URL}profile`,
    UPDATE_PROFILE: `${API_BASE_URL}update-profile`,
    FORGOT_PASSWORD: `${API_BASE_URL}forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}reset-password`,
    DELETE_USER: `${API_BASE_URL}users/delete-user`,
    AUTOLOGIN: `${API_BASE_URL}employer-login-auto`,
    UPDATE_DISPLAY_NAME: `${API_BASE_URL}users/update-display-name`,
    CHECK_VALID_TOKEN: `${API_BASE_URL}check-valid-token`,
    REGISTRATION_FIELDS: `${API_BASE_URL}registraton-fields`,
    REGISTRATION: `${API_BASE_URL}register`,
    COMPLETE_PROFILE: `${API_BASE_URL}complete-registration`,
    COMPANY_UPLOAD_LOGO: `${API_BASE_URL}company-upload-logo`,
    SAVE_NOTIFICATION: `${API_BASE_URL}inside-rodeo/save-notification`,
    VERIFY_EMAIL: `${API_BASE_URL}verify-email`,
    DELETE_ACCOUNT: `${API_BASE_URL}auth/delete-account`,
    RESEND_VERIFICATION: `${API_BASE_URL}resend-verification`,
    UPDATE_TWO_FACTOR_AUTH: `${API_BASE_URL}update-two-factor-auth`,
    VERIFY_2FA: `${API_BASE_URL}verify-2fa-otp`,
    SET_PERMISSIONS: (userId: string) => `${API_BASE_URL}users/${userId}/permissions`,
    ADD_COMPANY_BILLING_INFO: `${API_BASE_URL}add-company-billing-info`,
    GET_COMPANY_BILLING_INFO: `${API_BASE_URL}get-company-billing-info`,
    MY_ACTIVITY: `${API_BASE_URL}user-activity/my-activity`,
    ALL_USERS_ACTIVITY: `${API_BASE_URL}user-activity/all-users`,
    USER_DATA: `${API_BASE_URL}user-data`,
    NOTIFICATIONS: `${API_BASE_URL}user-activity/notifications`,
  },
  CMS: {
    GET_CMS: `${API_BASE_URL}inside-rodeo/get-cms`,
    GET_GAME_CMS_LIST: `${API_BASE_URL}inside-rodeo/get-rodeo-event-cms`,
    GET_PAGE_BY_SLUG: `${API_BASE_URL}cms/pages/slug`,
  },
  COMMON: {
    COUNTRY_LIST: `${API_BASE_URL}country/list`,
    GAME_DETAILS: `${API_BASE_URL}inside-rodeo/game-details/${APPLICATION_GLOBAL_SLUG}`,
    STATUS_MESSAGE: `${API_BASE_URL}common/get-status`,
    COUNTRIES: `${API_BASE_URL}common/get-countries`,
    STATES: `${API_BASE_URL}common/get-states`,
    CITIES: `${API_BASE_URL}common/get-cities`,
    CONTACTUS: `${API_BASE_URL}common/contact-us`,
    CONTACT_SUPPORT: `${API_BASE_URL}contact-support/submit`,
    SEO_LIST: `${API_BASE_URL}common/get-seo-details`,
    LANGUAGES: `${API_BASE_URL}common/languages`,
    WORK_PLACES: `${API_BASE_URL}common/work-places`,
    JOB_POST_TYPES: `${API_BASE_URL}common/job-post-types`,
    SKILLS: `${API_BASE_URL}common/skills`,
    INDUSTRIES: `${API_BASE_URL}common/industries`,

    COUNTRIES_NEW: `${API_BASE_URL}common/countries`,
    STATES_NEW: `${API_BASE_URL}common/states`,
    CITIES_NEW: `${API_BASE_URL}common/cities`,
    CURRENCIES: `${API_BASE_URL}common/currencies`,
    SALARY_RANGES: `${API_BASE_URL}common/salary-ranges`,
    FUNCTIONAL_AREAS: `${API_BASE_URL}common/functional-areas`,
    DESIGNATIONS: `${API_BASE_URL}common/designations`,
    ENHANCE_TEXT: `${API_BASE_URL}openai/enhance-text`,
    GENERATE_JOB_DESCRIPTION_SKILLS: `${API_BASE_URL}openai/generate-job-description-skills`,
    EDUCATION_LEVELS: `${API_BASE_URL}common/education-levels`,
    JOB_TITLE_SUGGESTIONS: `${API_BASE_URL}common/job-title-suggestions`,
    NATIONALITIES: `${API_BASE_URL}common/nationalities`,
  },
  JOB: {
    JOB_LIST: `${API_BASE_URL}job/employer-job/employer/`,
    EMPLOYER_JOBS: `${API_BASE_URL}employer-job/employer/`,
    CREATE_JOB: `${API_BASE_URL}employer-job/create`,
    UPDATE_JOB: `${API_BASE_URL}employer-job/update/`,
    JOB_DETAILS: `${API_BASE_URL}employer-job/view/`,
    UPDATE_STATUS: `${API_BASE_URL}job/update-status/`,
    CLONE_JOB: `${API_BASE_URL}job/clone/`,
    JOB_CANDIDATES: (jobId: string) => `${API_BASE_URL}job/${jobId}/candidates`,
    CANDIDATE_DETAILS: (jobId: string, candidateId: string) =>
      `${API_BASE_URL}job/${jobId}/candidate/${candidateId}/details`,
    SCREENING: `${API_BASE_URL}screening/get`,
    BULK_RESUME_UPLOAD: `${API_BASE_URL}resume/parse`,
    RESUME_UPLOAD_URLS: `${API_BASE_URL}resume/upload-urls`,
    RESUME_BATCH_PROCESS: (batchId: string) => `${API_BASE_URL}resume/batch/${batchId}/process`,
    JOB_STATUS_COUNTS: `${API_BASE_URL}reports/job-status-counts`,
    APPLIED_JOBS_LAST_SEVEN_DAYS: `${API_BASE_URL}reports/applied-jobs-day-wise-count`,
    JOB_ALL_STATUS_COUNTS: `${API_BASE_URL}reports/job-all-status-counts`,
    JOBSEEKER_DETAILS_BY_ID: `${API_BASE_URL}jobseekers/details-by-id`,
    TRIGGER_MATCHING: (jobEmpId: string) => `${API_BASE_URL}job/${jobEmpId}/trigger-matching`,
    USER_JOB_REFRESH_SET: `${API_BASE_URL}user-job-refresh/set`,
    USER_JOB_REFRESH_REMOVE: `${API_BASE_URL}user-job-refresh/remove`,
    USER_JOB_REFRESH_GET: `${API_BASE_URL}user-job-refresh/get`,
    DELETE_JOB: `${API_BASE_URL}employer-job/delete/`,
  },
  PERMISSIONS: {
    GET_PERMISSIONS: `${API_BASE_URL}permissions`,
    GET_PERMISSIONS_MATRIX: `${API_BASE_URL}permissions/matrix`,
    GET_PERMISSIONS_MODULE_JOBS: `${API_BASE_URL}permissions/module/jobs`,
  },
  USERS_MANAGEMENT: {
    CREATE_USER: `${API_BASE_URL}users`,
    UPLOAD_PROFILE_PHOTO: `${API_BASE_URL}users/upload-profile-photo/`,
    GET_USERS: `${API_BASE_URL}users`,
    UPDATE_USER: `${API_BASE_URL}users/`,
    GET_USER: `${API_BASE_URL}users/`,
    DELETE_USER: `${API_BASE_URL}users/`,
    RESEND_WELCOME_EMAIL: (userId: string) => `${API_BASE_URL}users/${userId}/resend-welcome-email`,
    UPDATE_ROLE_PERMISSIONS: (userId: string) => `${API_BASE_URL}users/${userId}/role-permissions`,
    GET_USER_PERMISSIONS: (userId: string) => `${API_BASE_URL}users/${userId}/permissions`,
    INVITE_USER: `${API_BASE_URL}users/invite`,
  },
  ROLES: {
    GET_ROLES: `${API_BASE_URL}roles`,
    GET_ROLE_PERMISSIONS: (roleId: string) => `${API_BASE_URL}roles/${roleId}/permissions`,
  },
  INTERVIEW: {
    AVALIBILITY_PAGE: `${API_BASE_URL}interview/availability`,
    ADD_AVAILABILITY: `${API_BASE_URL}interview/add-availability`,
    ADD_UNAVAILABILITY: `${API_BASE_URL}interview/add-unavailability`,
    DELETE_UNAVAILABILITY: `${API_BASE_URL}interview/delete-unavailability`,
    GET_SCHEDULE: `${API_BASE_URL}interview/schedule`,
    GET_AVAILABLE_TIME_SLOTS: `${API_BASE_URL}interview/available-time-slots`,
    SCHEDULE_REQUEST: `${API_BASE_URL}interview/schedule-request`,
    SCHEDULE_REQUEST_AI: `${API_BASE_URL}interview/schedule-request-ai`,
    GET_VIDEO_CALL_DATA: `${API_BASE_URL}interview/video-call-data`,
    RESCHEDULE_OR_CANCEL: `${API_BASE_URL}interview/reschedule-or-cancel-or-complete`,
    UPDATE_VALIDITY: `${API_BASE_URL}interview/update-validity`,
    SUBMIT_FEEDBACK: `${API_BASE_URL}interview/submit-feedback`,
    GET_EVALUATION: `${API_BASE_URL}interview-evaluation/get`,
  },
  AGORA_RECORDING: {
    START: `${API_BASE_URL}agora/recording/start`,
    STOP: `${API_BASE_URL}agora/recording/stop`,
    QUERY: `${API_BASE_URL}agora/recording/query`,
  },
  AGORA: {
    INSTANT_CALL: `${API_BASE_URL}agora/instant-call`,
  },
  SCREENING: {
    ADD_HISTORY: `${API_BASE_URL}screening/history/add`,
    GET_HISTORY: `${API_BASE_URL}screening/history/list`,
    UPDATE_STATUS: `${API_BASE_URL}screening/update-status`,
  },
  SUBSCRIPTION: {
    GET_SUBSCRIPTION_PLANS: `${API_BASE_URL}subscription-plans`,
    GET_INVOICES: `${API_BASE_URL}subscription-plans/invoices`,
    CREATE_PAYMENT: `${API_BASE_URL}subscription-plans/payment/create`,
    PAYMENT_SUCCESS: `${API_BASE_URL}subscription-plans/payment/success`,
    PAYMENT_CANCEL: `${API_BASE_URL}subscription-plans/payment/cancel`,
    CANCEL_SUBSCRIPTION: `${API_BASE_URL}subscription-plans/subscription/cancel`,
  },
  OFFER_LETTER: {
    SEND_FILE: `${API_BASE_URL}offer-letter/send-file`,
    SEND: `${API_BASE_URL}offer-letter/send`,
    GENERATE: `${API_BASE_URL}offer-letter/generate`,
    UPDATE_COUNTER_OFFER_STATUS: `${API_BASE_URL}offer-letter/update-counter-offer-status`,
    PENDING_ACTIONS: `${API_BASE_URL}offer-letter/pending-actions`,
  },
  VIDEO_CV: {
    GET_JOBSEEKERS_WITH_VIDEO: `${API_BASE_URL}jobseekers/with-video`,
  },
  CANDIDATES: {
    GET_JOBSEEKERS: `${API_BASE_URL}jobseekers/details`,
    GET_JOBSEEKERS_ADVANCED: `${API_BASE_URL}jobseekers/advanced-search`,
  },
  EXPERIENCE_RATING: {
    ADD: `${API_BASE_URL}experience-rating/add`,
    GET: `${API_BASE_URL}experience-rating/get`,
    UPDATE: `${API_BASE_URL}experience-rating/update`,
  },
};

export const ACTIONS = {
  // STORE Data in Redux
  LOADER: {
    SET_FP_STATUS: "ACTIONS/LOADER/SET_FP_STATUS",
  },
  GLOBAL: {
    SET_LOGIN_MODAL: "ACTIONS/GLOBAL/SET_LOGIN_MODAL",
  },
  USER: {
    LOGIN: "ACTIONS/USER/LOGIN",
    LOGIN_WITH_USERNAME: "ACTIONS/USER/LOGIN_WITH_USERNAME",
    ME: "ACTIONS/USER/ME",
    LOGOUT: "ACTIONS/USER/LOGOUT",
    FORGOT_PASSWORD: "ACTIONS/USER/FORGOT_PASSWORD",
    UPDATE_DISPLAY_NAME: "ACTIONS/USER/UPDATE_DISPLAY_NAME",
    SET_PERMISSIONS: "ACTIONS/USER/SET_PERMISSIONS",
    CLEAR_PERMISSIONS: "ACTIONS/USER/CLEAR_PERMISSIONS",
    SET_USER_DATA: "ACTIONS/USER/SET_USER_DATA",
  },
  COMMON: {
    MENU_LIST: "ACTIONS/COMMON/MENU_LIST",
    GAME_DETAILS: "ACTIONS/COMMON/GAME_DETAILS",
    BLOCKS: "ACTIONS/COMMON/BLOCKS",
    SEO_LIST: "ACTIONS/COMMON/SEO_LIST",
    REFFERER_URL: "ACTIONS/COMMON/REFFERER_URL",
    LANGUAGES: "ACTIONS/COMMON/LANGUAGES",
    WORK_PLACES: "ACTIONS/COMMON/WORK_PLACES",
    JOB_POST_TYPES: "ACTIONS/COMMON/JOB_POST_TYPES",
    SKILLS: "ACTIONS/COMMON/SKILLS",
    INDUSTRIES: "ACTIONS/COMMON/INDUSTRIES",
    COUNTRIES_NEW: "ACTIONS/COMMON/COUNTRIES_NEW",
    STATES_NEW: "ACTIONS/COMMON/STATES_NEW",
    CITIES_NEW: "ACTIONS/COMMON/CITIES_NEW",
    CURRENCIES: "ACTIONS/COMMON/CURRENCIES",
    SALARY_RANGES: "ACTIONS/COMMON/SALARY_RANGES",
    FUNCTIONAL_AREAS: "ACTIONS/COMMON/FUNCTIONAL_AREAS",
    DESIGNATIONS: "ACTIONS/COMMON/DESIGNATIONS",
    EDUCATION_LEVELS: "ACTIONS/COMMON/EDUCATION_LEVELS",
    JOB_TITLE_SUGGESTIONS: "ACTIONS/COMMON/JOB_TITLE_SUGGESTIONS",
    NATIONALITIES: "ACTIONS/COMMON/NATIONALITIES",
  },
  JOB: {
    GET_EMPLOYER_JOBS: "ACTIONS/JOB/GET_EMPLOYER_JOBS",
    GET_JOB_CANDIDATES: "ACTIONS/JOB/GET_JOB_CANDIDATES",
    GET_CANDIDATE_DETAILS: "ACTIONS/JOB/GET_CANDIDATE_DETAILS",
    GET_SCREENING: "ACTIONS/JOB/GET_SCREENING",
  },
  SUBSCRIPTION: {
    SET_PLANS: "ACTIONS/SUBSCRIPTION/SET_PLANS",
    SET_CURRENT_PLAN: "ACTIONS/SUBSCRIPTION/SET_CURRENT_PLAN",
    SET_LOADING: "ACTIONS/SUBSCRIPTION/SET_LOADING",
    CLEAR_DATA: "ACTIONS/SUBSCRIPTION/CLEAR_DATA",
  },
  VIDEO_CV: {
    GET_JOBSEEKERS_WITH_VIDEO: "ACTIONS/VIDEO_CV/GET_JOBSEEKERS_WITH_VIDEO",
  },
  CANDIDATES: {
    GET_JOBSEEKERS: "ACTIONS/CANDIDATES/GET_JOBSEEKERS",
    GET_JOBSEEKERS_ADVANCED: "ACTIONS/CANDIDATES/GET_JOBSEEKERS_ADVANCED",
  },
};

export const SAGA_ACTIONS = {
  // GET Store data from Redux
  USER: {
    LOGIN: "SAGA_ACTIONS/USER/LOGIN",
    AUTO_LOGIN: "SAGA_ACTIONS/USER/AUTO_LOGIN",
    REGISTRATION: "SAGA_ACTIONS/USER/REGISTRATION",
    COMPLETE_PROFILE: "SAGA_ACTIONS/USER/COMPLETE_PROFILE",
    FORGOT_PASSWORD: "SAGA_ACTIONS/USER/FORGOT_PASSWORD",
    RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
    LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
    DETAILS: "SAGA_ACTIONS/USER/DETAILS",
    UPDATE_PROFILE: "SAGA_ACTIONS/USER/UPDATE_PROFILE",
    COMPANY_UPLOAD_LOGO: "SAGA_ACTIONS/USER/COMPANY_UPLOAD_LOGO",
    UPDATE_DISPLAY_NAME: "SAGA_ACTIONS/USER/UPDATE_DISPLAY_NAME",
    CHECK_VALID_TOKEN: "SAGA_ACTIONS/USER/CHECK_VALID_TOKEN",
    REGISTRATION_FIELDS: "SAGA_ACTIONS/USER/REGISTRATION_FIELDS",
    DELETE_USER: "SAGA_ACTIONS/USER/DELETE_USER",
    SAVE_NOTIFICATION: "SAGA_ACTIONS/USER/SAVE_NOTIFICATION",
    VERIFY_EMAIL: "SAGA_ACTIONS/USER/VERIFY_EMAIL",
    RESEND_VERIFICATION: "SAGA_ACTIONS/USER/RESEND_VERIFICATION",
    UPDATE_TWO_FACTOR_AUTH: "SAGA_ACTIONS/USER/UPDATE_TWO_FACTOR_AUTH",
    VERIFY_2FA: "SAGA_ACTIONS/USER/VERIFY_2FA",
    DELETE_ACCOUNT: "SAGA_ACTIONS/USER/DELETE_ACCOUNT",
    GET_PERMISSIONS: "SAGA_ACTIONS/USER/GET_PERMISSIONS",
    ADD_COMPANY_BILLING_INFO: "SAGA_ACTIONS/USER/ADD_COMPANY_BILLING_INFO",
    GET_COMPANY_BILLING_INFO: "SAGA_ACTIONS/USER/GET_COMPANY_BILLING_INFO",
    MY_ACTIVITY: "SAGA_ACTIONS/USER/MY_ACTIVITY",
    ALL_USERS_ACTIVITY: "SAGA_ACTIONS/USER/ALL_USERS_ACTIVITY",
    USER_DATA: "SAGA_ACTIONS/USER/USER_DATA",
    NOTIFICATIONS: "SAGA_ACTIONS/USER/NOTIFICATIONS",
  },
  CMS: {
    GET_CMS: "SAGA_ACTIONS/COMMON/GET_CMS",
    GET_GAME_CMS_LIST: "SAGA_ACTIONS/COMMON/GET_GAME_CMS_LIST",
    GET_PAGE_BY_SLUG: "SAGA_ACTIONS/CMS/GET_PAGE_BY_SLUG",
  },
  COMMON: {
    COUNTRY_LIST: "SAGA_ACTIONS/COMMON/COUNTRY_LIST",
    GAME_DETAILS: "SAGA_ACTIONS/GAME/GAME_DETAILS",
    COUNTRIES: "SAGA_ACTIONS/COMMON/COUNTRIES",
    STATES: "SAGA_ACTIONS/COMMON/STATES",
    CITIES: "SAGA_ACTIONS/COMMON/CITIES",
    STATES_NEW: "SAGA_ACTIONS/COMMON/STATES_NEW",
    CONTACTUS: "SAGA_ACTIONS/COMMON/CONTACTUS",
    CONTACT_SUPPORT: "SAGA_ACTIONS/COMMON/CONTACT_SUPPORT",
    SEO_LIST: "SAGA_ACTIONS/COMMON/SEO_LIST",
    LANGUAGES: "SAGA_ACTIONS/COMMON/LANGUAGES",
    WORK_PLACES: "SAGA_ACTIONS/COMMON/WORK_PLACES",
    JOB_POST_TYPES: "SAGA_ACTIONS/COMMON/JOB_POST_TYPES",
    SKILLS: "SAGA_ACTIONS/COMMON/SKILLS",
    INDUSTRIES: "SAGA_ACTIONS/COMMON/INDUSTRIES",
    COUNTRIES_NEW: "SAGA_ACTIONS/COMMON/COUNTRIES_NEW",
    CITIES_NEW: "SAGA_ACTIONS/COMMON/CITIES_NEW",
    CURRENCIES: "SAGA_ACTIONS/COMMON/CURRENCIES",
    SALARY_RANGES: "SAGA_ACTIONS/COMMON/SALARY_RANGES",
    FUNCTIONAL_AREAS: "SAGA_ACTIONS/COMMON/FUNCTIONAL_AREAS",
    DESIGNATIONS: "SAGA_ACTIONS/COMMON/DESIGNATIONS",
    ENHANCE_TEXT: "SAGA_ACTIONS/COMMON/ENHANCE_TEXT",
    GENERATE_JOB_DESCRIPTION_SKILLS: "SAGA_ACTIONS/COMMON/GENERATE_JOB_DESCRIPTION_SKILLS",
    EDUCATION_LEVELS: "SAGA_ACTIONS/COMMON/EDUCATION_LEVELS",
    JOB_TITLE_SUGGESTIONS: "SAGA_ACTIONS/COMMON/JOB_TITLE_SUGGESTIONS",
    NATIONALITIES: "SAGA_ACTIONS/COMMON/NATIONALITIES",
  },
  JOB_POSTING: {
    UPDATE_FORM_DATA: "SAGA_ACTIONS/JOB_POSTING/UPDATE_FORM_DATA",
    UPDATE_CURRENT_STEP: "SAGA_ACTIONS/JOB_POSTING/UPDATE_CURRENT_STEP",
    RESET_FORM: "SAGA_ACTIONS/JOB_POSTING/RESET_FORM",
    SET_SELECTED_SKILLS: "SAGA_ACTIONS/JOB_POSTING/SET_SELECTED_SKILLS",
    SET_SELECTED_LANGUAGES: "SAGA_ACTIONS/JOB_POSTING/SET_SELECTED_LANGUAGES",
    SET_SELECTED_COUNTRY: "SAGA_ACTIONS/JOB_POSTING/SET_SELECTED_COUNTRY",
    SET_SELECTED_CURRENCY: "SAGA_ACTIONS/JOB_POSTING/SET_SELECTED_CURRENCY",
    CREATE_JOB: "SAGA_ACTIONS/JOB_POSTING/CREATE_JOB",
    UPDATE_JOB: "SAGA_ACTIONS/JOB_POSTING/UPDATE_JOB",
  },
  JOB: {
    GET_EMPLOYER_JOBS: "SAGA_ACTIONS/JOB/GET_EMPLOYER_JOBS",
    GET_JOB_DETAILS: "SAGA_ACTIONS/JOB/GET_JOB_DETAILS",
    UPDATE_JOB_STATUS: "SAGA_ACTIONS/JOB/UPDATE_JOB_STATUS",
    CLONE_JOB: "SAGA_ACTIONS/JOB/CLONE_JOB",
    GET_JOB_CANDIDATES: "SAGA_ACTIONS/JOB/GET_JOB_CANDIDATES",
    GET_CANDIDATE_DETAILS: "SAGA_ACTIONS/JOB/GET_CANDIDATE_DETAILS",
    GET_SCREENING: "SAGA_ACTIONS/JOB/GET_SCREENING",
    BULK_RESUME_UPLOAD: "SAGA_ACTIONS/JOB/BULK_RESUME_UPLOAD",
    GET_JOB_STATUS_COUNTS: "SAGA_ACTIONS/JOB/GET_JOB_STATUS_COUNTS",
    GET_APPLIED_JOBS_LAST_SEVEN_DAYS: "SAGA_ACTIONS/JOB/GET_APPLIED_JOBS_LAST_SEVEN_DAYS",
    GET_JOB_ALL_STATUS_COUNTS: "SAGA_ACTIONS/JOB/GET_JOB_ALL_STATUS_COUNTS",
    GET_JOBSEEKER_DETAILS_BY_ID: "SAGA_ACTIONS/JOB/GET_JOBSEEKER_DETAILS_BY_ID",
    TRIGGER_MATCHING: "SAGA_ACTIONS/JOB/TRIGGER_MATCHING",
    USER_JOB_REFRESH_SET: "SAGA_ACTIONS/JOB/USER_JOB_REFRESH_SET",
    USER_JOB_REFRESH_REMOVE: "SAGA_ACTIONS/JOB/USER_JOB_REFRESH_REMOVE",
    USER_JOB_REFRESH_GET: "SAGA_ACTIONS/JOB/USER_JOB_REFRESH_GET",
    DELETE_JOB: "SAGA_ACTIONS/JOB/DELETE_JOB",
  },
  PERMISSIONS: {
    GET_PERMISSIONS: "SAGA_ACTIONS/PERMISSIONS/GET_PERMISSIONS",
    GET_PERMISSIONS_MATRIX: "SAGA_ACTIONS/PERMISSIONS/GET_PERMISSIONS_MATRIX",
    GET_PERMISSIONS_MODULE_JOBS: "SAGA_ACTIONS/PERMISSIONS/GET_PERMISSIONS_MODULE_JOBS",
  },
  USERS_MANAGEMENT: {
    CREATE_USER: "SAGA_ACTIONS/USERS_MANAGEMENT/CREATE_USER",
    UPLOAD_PROFILE_PHOTO: "SAGA_ACTIONS/USERS_MANAGEMENT/UPLOAD_PROFILE_PHOTO",
    GET_USERS: "SAGA_ACTIONS/USERS_MANAGEMENT/GET_USERS",
    UPDATE_USER: "SAGA_ACTIONS/USERS_MANAGEMENT/UPDATE_USER",
    GET_USER: "SAGA_ACTIONS/USERS_MANAGEMENT/GET_USER",
    DELETE_USER: "SAGA_ACTIONS/USERS_MANAGEMENT/DELETE_USER",
    RESEND_WELCOME_EMAIL: "SAGA_ACTIONS/USERS_MANAGEMENT/RESEND_WELCOME_EMAIL",
    UPDATE_ROLE_PERMISSIONS: "SAGA_ACTIONS/USERS_MANAGEMENT/UPDATE_ROLE_PERMISSIONS",
    GET_USER_PERMISSIONS: "SAGA_ACTIONS/USERS_MANAGEMENT/GET_USER_PERMISSIONS",
    INVITE_USER: "SAGA_ACTIONS/USERS_MANAGEMENT/INVITE_USER",
  },
  ROLES: {
    GET_ROLES: "SAGA_ACTIONS/ROLES/GET_ROLES",
    GET_ROLE_PERMISSIONS: "SAGA_ACTIONS/ROLES/GET_ROLE_PERMISSIONS",
  },
  INTERVIEW: {
    ADD_AVAILABILITY: "SAGA_ACTIONS/INTERVIEW/ADD_AVAILABILITY",
    ADD_UNAVAILABILITY: "SAGA_ACTIONS/INTERVIEW/ADD_UNAVAILABILITY",
    DELETE_UNAVAILABILITY: "SAGA_ACTIONS/INTERVIEW/DELETE_UNAVAILABILITY",
    GET_SCHEDULE: "SAGA_ACTIONS/INTERVIEW/GET_SCHEDULE",
    GET_AVAILABLE_TIME_SLOTS: "SAGA_ACTIONS/INTERVIEW/GET_AVAILABLE_TIME_SLOTS",
    SCHEDULE_REQUEST: "SAGA_ACTIONS/INTERVIEW/SCHEDULE_REQUEST",
    SCHEDULE_REQUEST_AI: "SAGA_ACTIONS/INTERVIEW/SCHEDULE_REQUEST_AI",
    GET_VIDEO_CALL_DATA: "SAGA_ACTIONS/INTERVIEW/GET_VIDEO_CALL_DATA",
    RESCHEDULE_OR_CANCEL: "SAGA_ACTIONS/INTERVIEW/RESCHEDULE_OR_CANCEL",
    UPDATE_VALIDITY: "SAGA_ACTIONS/INTERVIEW/UPDATE_VALIDITY",
    SUBMIT_FEEDBACK: "SAGA_ACTIONS/INTERVIEW/SUBMIT_FEEDBACK",
    GET_EVALUATION: "SAGA_ACTIONS/INTERVIEW/GET_EVALUATION",
  },
  AGORA_RECORDING: {
    START: "SAGA_ACTIONS/AGORA_RECORDING/START",
    STOP: "SAGA_ACTIONS/AGORA_RECORDING/STOP",
    QUERY: "SAGA_ACTIONS/AGORA_RECORDING/QUERY",
  },
  AGORA: {
    INSTANT_CALL: "SAGA_ACTIONS/AGORA/INSTANT_CALL",
  },
  SCREENING: {
    ADD_FEEDBACK: "SAGA_ACTIONS/SCREENING/ADD_FEEDBACK",
    GET_HISTORY: "SAGA_ACTIONS/SCREENING/GET_HISTORY",
    UPDATE_STATUS: "SAGA_ACTIONS/SCREENING/UPDATE_STATUS",
  },
  SUBSCRIPTION: {
    GET_SUBSCRIPTION_PLANS: "SAGA_ACTIONS/SUBSCRIPTION/GET_SUBSCRIPTION_PLANS",
    GET_INVOICES: "SAGA_ACTIONS/SUBSCRIPTION/GET_INVOICES",
    CREATE_PAYMENT: "SAGA_ACTIONS/SUBSCRIPTION/CREATE_PAYMENT",
    PAYMENT_SUCCESS: "SAGA_ACTIONS/SUBSCRIPTION/PAYMENT_SUCCESS",
    PAYMENT_CANCEL: "SAGA_ACTIONS/SUBSCRIPTION/PAYMENT_CANCEL",
    CANCEL_SUBSCRIPTION: "SAGA_ACTIONS/SUBSCRIPTION/CANCEL_SUBSCRIPTION",
  },
  OFFER_LETTER: {
    SEND_FILE: "SAGA_ACTIONS/OFFER_LETTER/SEND_FILE",
    SEND: "SAGA_ACTIONS/OFFER_LETTER/SEND",
    GENERATE: "SAGA_ACTIONS/OFFER_LETTER/GENERATE",
    UPDATE_COUNTER_OFFER_STATUS: "SAGA_ACTIONS/OFFER_LETTER/UPDATE_COUNTER_OFFER_STATUS",
    PENDING_ACTIONS: "SAGA_ACTIONS/OFFER_LETTER/PENDING_ACTIONS",
  },
  VIDEO_CV: {
    GET_JOBSEEKERS_WITH_VIDEO: "SAGA_ACTIONS/VIDEO_CV/GET_JOBSEEKERS_WITH_VIDEO",
  },
  CANDIDATES: {
    GET_JOBSEEKERS: "SAGA_ACTIONS/CANDIDATES/GET_JOBSEEKERS",
    GET_JOBSEEKERS_ADVANCED: "SAGA_ACTIONS/CANDIDATES/GET_JOBSEEKERS_ADVANCED",
  },
  EXPERIENCE_RATING: {
    ADD: "SAGA_ACTIONS/EXPERIENCE_RATING/ADD",
    GET: "SAGA_ACTIONS/EXPERIENCE_RATING/GET",
    UPDATE: "SAGA_ACTIONS/EXPERIENCE_RATING/UPDATE",
  },
};

export * from "./site_statics";
export * from "./site_urls";
export * from "./functions";
export * from "./canvasUtils";
export * from "./card_utils";
